import { AfterViewInit, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { AuthService, FeatureToggleService } from '@agenda-customer-ui/data-access';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, AsyncPipe, UpperCasePipe } from '@angular/common';
import { isSourceFordPass, isSourcePerks } from '@core/utils';
import { TabsComponent, TabComponent } from '@components/molecules';
import { RevisionComponent } from './content/revision/revision.component';
import { ScheduleComponent } from './content/schedule/schedule.component';
import { RecallComponent } from './content/recall/recall.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'main-container-history',
    templateUrl: './main-container-history.component.html',
    styleUrls: ['./main-container-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgClass, TabsComponent, TabComponent, RevisionComponent, ScheduleComponent, RecallComponent, AsyncPipe, UpperCasePipe, TranslateModule]
})
export class HistoryMainContainerComponent implements AfterViewInit {
  isFordPass = isSourceFordPass(this.authService.urlInfo.source);
  isPerks = isSourcePerks(this.authService.urlInfo.source);

  showRecall = false;

  constructor(
    private cdr: ChangeDetectorRef,
    public authService: AuthService,
    public featureToggleService: FeatureToggleService,
  ) { }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
}
